"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SegmentManager", {
  enumerable: true,
  get: function get() {
    return _consentManager.SegmentManager;
  }
});
exports.writeKey = exports.categories = exports.tagDefs = exports.apiMethods = exports.apiHost = exports.cdnHost = void 0;

var _consentManager = require("./consent-manager"); // const cdnHost = 'cdn.segment.com';
// const apiHost = 'api.segment.com';


var cdnHost = 'assets.rasa.com/proxies/segment/cdn';
exports.cdnHost = cdnHost;
var apiHost = 'assets.rasa.com/proxies/segment/api'; // assets.rasa.com/proxies/segment/cdn

exports.apiHost = apiHost;
var writeKey = 'lnw5SGYAUHqAoQVDXqffpaPXXDe2x1ys';
exports.writeKey = writeKey;
var apiMethods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on', 'addSourceMiddleware', // required for consent manager
'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware'];
exports.apiMethods = apiMethods;
var snippet = "\n!function () {\n  var analytics = window.analytics = window.analytics || [];\n  if (!analytics.initialize)\n    if (analytics.invoked) window.console && console.error && console.error(\"Segment snippet included twice.\");\n    else {\n      analytics.invoked = !0;\n      analytics.methods = ".concat(JSON.stringify(apiMethods), ";\n      analytics.factory = function (e) {\n        return function () {\n          var t = Array.prototype.slice.call(arguments);\n          t.unshift(e);\n          analytics.push(t);\n          return analytics\n        }\n      };\n      for (var e = 0; e < analytics.methods.length; e++) {\n        var key = analytics.methods[e];\n        analytics[key] = analytics.factory(key)\n      }\n      analytics.load = function (key, e) {\n        var t = document.createElement(\"script\");\n        t.type = \"text/javascript\";\n        t.async = !0;\n        t.src = \"https://").concat(cdnHost, "/analytics.js/v1/\" + key + \"/analytics.min.js\";\n        var n = document.getElementsByTagName(\"script\")[0];\n        n.parentNode.insertBefore(t, n);\n        analytics._loadOptions = e\n      };\n      analytics.SNIPPET_VERSION = \"4.13.1\";\n      /* load() AND page() calls removed here! */\n    }\n}();\n");
/*
      analytics.load("${writeKey}");
      analytics.page();

*/

function createTags(_ref) {
  var writeKey = _ref.writeKey,
      cdnHost = _ref.cdnHost,
      apiHost = _ref.apiHost,
      apiMethods = _ref.apiMethods;
  cdnHost = cdnHost.trim().replace(/^https?:\/\//, '');
  apiHost = apiHost.trim().replace(/^https?:\/\//, '');
  return {
    headTags: [{
      key: 'segment-cdn',
      tagName: 'link',
      attributes: {
        rel: 'preconnect',
        href: cdnHost
      }
    }, {
      key: 'segment-api',
      tagName: 'link',
      attributes: {
        rel: 'preconnect',
        href: apiHost
      }
    }],
    preBodyTags: [],
    postBodyTags: [{
      key: 'segment-analytics',
      tagName: 'script',
      attributes: {
        type: 'application/javascript'
      },
      innerHTML: snippet
    }]
  };
}

var tagDefs = {
  headTags: [{
    key: 'segment-cdn-preconnect',
    tagName: 'link',
    attributes: {
      rel: 'preconnect',
      href: "https://".concat(cdnHost)
    }
  }, {
    key: 'segment-api-preconnect',
    tagName: 'link',
    attributes: {
      rel: 'preconnect',
      href: "https://".concat(apiHost)
    }
  }, {
    key: 'segment-analytics',
    tagName: 'script',
    attributes: {
      type: 'application/javascript'
    },
    innerHTML: snippet
  }],
  preBodyTags: [],
  postBodyTags: []
};
exports.tagDefs = tagDefs;
var categories = [{
  id: 'analytics',
  name: 'Analytics',
  description: 'Collecting of visitor statistics & analysing browsing behavior.',
  purposes: 'Visitor Statistics, Browsing Behavior',
  destinationIDs: [// these match `creationID` values returned from the /integrations API
  'Google Analytics', 'HubSpot', 'Hotjar', 'Visual Tagger', 'Google AdWords New']
}];
exports.categories = categories;